import React from "react"
import { Col, Row, Form } from "react-bootstrap"
import { getIn } from "formik"
import FormLabel from "./formLabel"
import NumberFormat from "react-number-format"

function FormMobileTextBox(props) {
  const { textDesc, form, field, maxLength } = props

  const errorsMsg = getIn(form.errors, field.name)

  const inputErrorClassName = (touched, errors, inputName) => {
    //  (clickedNext && errors[inputName]) ||
    return errors[inputName] && touched[inputName] ? "mobileError" : null
  }

  const inputErrorMessage = (touched, errors, inputName) => {
    //  (clickedNext && errors[inputName]) ||
    return errors[inputName] && touched[inputName] ? (
      <span className="InputError">{errorsMsg}</span>
    ) : null
  }

  return (
    <Form.Group>
      <Row>
        <FormLabel text={textDesc} />
        <Col xs={12} md={6} className="marginTop10px mobileInput">
          <Col
            xs={3}
            md={3}
            className={
              "mobilePrefix " +
              inputErrorClassName(form.touched, form.errors, field.name)
            }
          >
            <span className="ReviewEditButton">+65 </span>
          </Col>
          <NumberFormat
            name={field.name}
            className={
              "col-9 mobileInputbox " +
              inputErrorClassName(form.touched, form.errors, field.name)
            }
            type="text"
            maxLength={maxLength}
            autoComplete="new-password"
            value={field.value || ""}
            onChange={event => {
              form.handleChange(event)
            }}
            onBlur={event => {
              form.handleBlur(event)
            }}
          />
          {inputErrorMessage(form.touched, form.errors, field.name)}
        </Col>
      </Row>
    </Form.Group>
  )
}
export default FormMobileTextBox
